import { sendNotification } from "actions/Notifications";
import { handleRequestError } from "actions/ErrorHandling";

export const sendOrdersToAbbiamo = (orders) => async (dispatch, getState, api) => {
  const distributionCenterId = getState().distributionCenters.selected;

  try {
    const response = await api.post("/abbiamo/send-orders", {
      orders,
      distributionCenterId,
    });

    const data = response.data || {};
    const queued = data.queued !== undefined ? data.queued : orders.length;
    const ignored = data.ignored !== undefined ? data.ignored : 0;

    dispatch(
      sendNotification({
        type: "success",
        message: `${queued} enfileirado(s) / ${ignored} ignorado(s)`,
      })
    );
  
    return data;
  } catch (err) {
    dispatch(handleRequestError(err, false));
    const message = err.response?.data?.message || err.message;
    dispatch(
      sendNotification({
        type: "error",
        message,
      })
    );
    return null;
  }
};

export const resendOrdersToAbbiamo = (orders) => async (
  dispatch,
  getState,
  api
) => {
  const distributionCenterId = getState().distributionCenters.selected;

  try {
    const response = await api.post("/abbiamo/resend-orders", {
      orders,
      distributionCenterId,
    });

    const data = response.data || {};
    const queued = data.queued || 0;
    const notQueued =
      (data.ignored || []).length +
      (data.conflicts || []).length +
      (data.failed || []).length;

    dispatch(
      sendNotification({
        type: "success",
        message: `${queued} enfileirado(s) para reenvio / ${notQueued} não enviado(s)`,
      })
    );
    return data;
  } catch (err) {
    dispatch(handleRequestError(err, false));
    const message = err.response?.data?.message || err.message;
    dispatch(
      sendNotification({
        type: "error",
        message,
      })
    );
    return null;
  }
};
